import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import {
  getCountryCallingCode,
  getCountries,
  isValidPhoneNumber,
} from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Loading from '../../ReusableFunctions/Loader';
import { getDronePilots } from '../../apis/dronePilots';
import { checkOnboardingStatus } from '../../apis/operator';
import Toggle from 'react-toggle';
import infosvg from '../../assets/infosvg.svg';
import { login } from '../../apis/authentication';
import ReactCountryFlag from "react-country-flag"


       const customStyles = {
  control: (provided) => ({
    ...provided,
    minWidth: "100px",
    maxWidth: "150px",
    height: "35px",
   paddingBottom:"8px",
    fontSize: "14px",
    border: "none",
    boxShadow: "none"
  }),
  menu: (provided) => ({
    ...provided,
    maxHeight: "150px",
    overflowY: "auto"
  }),
  option: (provided, state) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
  }),
  singleValue: (provided) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  })
};


const AddDronePilotForm = React.forwardRef(({ onNext }, ref) => {
  const [pilotDetails, setPilotDetails] = useState({
    first_name: "",
    last_name: "",
    phone: "", // local number only
    email: "",
    licence_id: "",
    location_id: undefined,
    assigned_drone: undefined,
  });

  const [initialData, setInitialData] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    licence_id: "",
  });

 const countryOptions = getCountries().map((country) => ({
   value: country,
   label: (
     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
       <ReactCountryFlag 
         countryCode={country}
         svg
         style={{
           width: '1.2em',
           height: '1.2em',
         }}
         title={country}
       />
       <span>{`+${getCountryCallingCode(country)}`}</span>
     </div>
   ),
   countryCode: country // preserve the country code
 }));

  const [selectedCountryOption, setSelectedCountryOption] = useState(
    countryOptions.find(opt => opt.value === "IN")
  );
 const[toggleDisable,setToggleDisable]=useState(false);
  const [isDspWorkAsPilot, setIsDspWorkAsPilot] = useState(true);
  const [isWorkAsPilotCompleted, setIsWorkAsPilotCompleted] = useState(false);
  const [countryCode, setCountryCode] = useState(`+${getCountryCallingCode("IN")}`);
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    licence_id: "",
  });

  const validateField = (name, value, customCountryCode) => {
    let error = "";
    const nameRegex = /^[A-Za-z]+$/; // only letters
    const licenceRegex = /^[A-Za-z0-9]+$/ 
    switch (name) {
      case "first_name":
        if (!value.trim()) {
          error = "First name is required";
        } else if (value.length < 3 || value.length > 30) {
          error = "First name should be between 3 to 30 characters";
        } else if (!nameRegex.test(value)) {
          error = "First name must contain letters only";
        }
        break;
  
      case "last_name":
        if (!value.trim()) {
          error = "Last name is required";
        } else if (value.length < 3 || value.length > 30) {
          error = "Last name should be between 3 to 30 characters";
        } else if (!nameRegex.test(value)) {
          error = "Last name must contain letters only";
        }
        break;
  
      case "phone":
        if (!value) {
          error = "Phone number is required";
        } else {
          const testFull = `${customCountryCode || countryCode}${value}`;
          if (!isValidPhoneNumber(testFull)) {
            error = "Invalid phone number for selected country";
          }
        }
        break;

         case "email":
      const isNonIndian = (customCountryCode || countryCode) !== "+91";

      if (isNonIndian && (!value || value.trim() === "")) {
        error = "Email is required";
      } else if (value) {
        // Regex for proper email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          error = "Enter a valid email address";
        }
      }
      break;

  
        case "licence_id":
          if (value && value.trim()) {
            if (value.length < 3 || value.length > 20) {
              error = "License number should be between 3 to 20 characters";
            } else if (!licenceRegex.test(value)) {
              error = "License number must contain only letters and numbers";
            }
          }
          break;
  
      default:
        break;
    }
  
    setErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };
  

  const handleChange = (name, value) => {
    setPilotDetails((prev) => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  const handlePhoneChange = (e) => {
    const localNumber = e.target.value.replace(/\D/g, '');
    handleChange("phone", localNumber);
  };

  const handleCountryChange = (option) => {
    setSelectedCountryOption(option);
    const newCode = `+${getCountryCallingCode(option.value)}`;
    setCountryCode(newCode);
    validateField("phone", pilotDetails.phone, newCode);
  };

  const getOnBoardingStatusFunc = async () => {
    Loading.set(true);
    try {
      const res=await login();
      setIsDspWorkAsPilot(()=>res.dsp?.settings?.isDSPWorkingAsPilot || false);
      setIsWorkAsPilotCompleted(()=>res.dsp?.settings?.isDSPWorkingAsPilot || false);
      const data = await checkOnboardingStatus();
      setPilotDetails((prev) => ({
        ...prev,
        location_id: data.existingLocation?.id,
        assigned_drone: data.existingDrone?.drone_uin,
        drone_id:data.existingDrone?.id,
      }));
    } catch (err) {
      console.log("Error fetching onboarding status", err);
    }
  };

  const getDronePilotFunc = async () => {
 
    try {
      const { dronePilots } = await getDronePilots();
      const existingPilot = dronePilots.length>0? dronePilots[0]:undefined;
      if(!existingPilot){
        setIsDspWorkAsPilot(true);
        return ;
      }

      if(existingPilot){
        setToggleDisable(()=>true);
      }

      const pilotData = {
        id: existingPilot.id || undefined,
        first_name: existingPilot.first_name || "",
        last_name: existingPilot.last_name || "",
        phone: existingPilot.phone || "",
        licence_id: existingPilot.licence_id || "",
      };

      const dbCountryCode = existingPilot.country_code; // e.g. '+91'
      if (dbCountryCode) {
        const numericCode = dbCountryCode.replace('+', '');
        const matched = countryOptions.find(
          opt => getCountryCallingCode(opt.value) === numericCode
        );
        if (matched) {
          setSelectedCountryOption(matched);
          setCountryCode(`+${numericCode}`);
        }
      }

      setPilotDetails((prev) => ({ ...prev, ...pilotData }));
      setInitialData(pilotData);
      setIsEditing(true);
    } catch (err) {
      console.log("Error while getting the drone pilots ", err);
    } finally {
      Loading.set(false);
    }
  };

  const validateForm = () => {
    if (isDspWorkAsPilot) return true;
    const firstNameValid = validateField("first_name", pilotDetails.first_name);
    const lastNameValid = validateField("last_name", pilotDetails.last_name);
    const phoneValid = validateField("phone", pilotDetails.phone);
    const emailValid = validateField("email", pilotDetails.email);
    const licenseValid = validateField("licence_id", pilotDetails.licence_id);
    return firstNameValid && lastNameValid && phoneValid && emailValid && licenseValid;
  };

  const handleWorkAsPilotToggle = () => {
    setIsDspWorkAsPilot((prev)=>!prev);
  };

  React.useImperativeHandle(ref, () => ({
    submitForm: () => {
      if (validateForm()) {
        if (isDspWorkAsPilot) {
          // If DSP is working as pilot, pass the flag and drone details
          const payload = {
            isDspWorkAsPilot: true,
            assigned_drone: pilotDetails.assigned_drone,
            drone_id: pilotDetails.drone_id,
            isCompleted: isWorkAsPilotCompleted
          };
          onNext(payload, false);
          return true;
        } else {
          // Original logic for adding/updating pilot
          const payload = {
            ...pilotDetails,
            country_code: countryCode?countryCode?.split("+")[1]:undefined,
            is_active: true,
            isDspWorkAsPilot: false
          };
          const keysToCompare = ["first_name", "last_name", "phone", "licence_id"];
          const hasChanged = keysToCompare.some(
            (key) => pilotDetails[key] !== initialData[key]
          );
          onNext(hasChanged ? payload : null, isEditing);
          return true;
        }
      }
      return false;
    },
  }));

  useEffect(() => {
    getOnBoardingStatusFunc();
    getDronePilotFunc();
  }, []);

  return (
    <div className="flex flex-col h-[100%] gap-1">
      <div style={{ display: "flex", gap: "0.2rem", flexDirection: "column" }}>
        <p className="form-title" style={{ marginBottom: "0px" }}>Add Pilot</p>
        <span className="font-manrope text-[15px] font-[500] tracking-wide">
          You can add multiple pilots from pilot section.
        </span>
      </div>


      <div  className='w-[60%] mt-2 mb-4 flex justify-between items-start'>
        <div className=''>
      <span className='font-manrope text-[#1E1E1E] font-[700] text-[17px]'>I also work as pilot</span>
      {isDspWorkAsPilot &&<div className='flex items-center bg-[#EBF1FF] w-[300px] py-[4px] px-2 gap-[0.2rem] mt-[4px]  border  border-[#0F5EFF]' >
        <img src={infosvg} alt={"info"} width={15} height={15}/>
        <span className='font-manrope fonr-[500] text-[#0F5EFF] text-[13px]' >You can add more pilots from dashboard .</span>
         </div>}
        </div>
      <div className="pilot_toggle flex flex-col mt-[4px] items-end gap-[2px]" style={{  cusrsor:"pointer"}}>
        <Toggle
          height={"20px"}
          icons={false}
          checked={isDspWorkAsPilot}
          onChange={handleWorkAsPilotToggle}
          disabled={toggleDisable}
        />
      </div>
     </div>
   {!isDspWorkAsPilot && (
      <div className="h-[90%] flex flex-col gap-[15px] pt-2 ">
        {/* first_name */}
        <div className="flex flex-col gap-[0.2rem]">
          <label htmlFor="first_name" className="input-label">
            What is the pilot first name?<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            id="first_name"
            placeholder='Enter first name'
            value={pilotDetails.first_name}
            onChange={(e) => handleChange("first_name", e.target.value)}
            style={{
              width: "50%", height: "40px", padding: "8px 12px", borderRadius: "4px",
              border: errors.first_name ? "1px solid #D92D20" : "1px solid #D0D5DD",
              fontSize: "14px"
            }}
          />
          {errors.first_name && <span style={{ color: "#D92D20", fontSize: "12px" }}>{errors.first_name}</span>}
        </div>

        {/* last_name */}
        <div className="flex flex-col gap-[0.2rem]">
          <label htmlFor="last_name" className="input-label">
            What is the pilot last name?<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            id="last_name"
            placeholder='Enter last name'
            value={pilotDetails.last_name}
            onChange={(e) => handleChange("last_name", e.target.value)}
            style={{
              width: "50%", height: "40px", padding: "8px 12px", borderRadius: "4px",
              border: errors.last_name ? "1px solid #D92D20" : "1px solid #D0D5DD",
              fontSize: "14px"
            }}
          />
          {errors.last_name && <span style={{ color: "#D92D20", fontSize: "12px" }}>{errors.last_name}</span>}
        </div>

        {/* phone */}
        <div className="flex flex-col gap-[0.2rem]">
          <label htmlFor="phone" className="input-label">
            What is pilot mobile number?<span style={{ color: "red" }}>*</span>
          </label>
          <div style={{
            display: "flex", alignItems: "center",
            border: errors.phone ? "1px solid #D92D20" : "1px solid #D0D5DD",
            borderRadius: "4px", width: "50%", height: "40px"
          }}>
            {/* react-select country code */}
            <Select
              value={selectedCountryOption}
              onChange={handleCountryChange}
              options={countryOptions}
              isSearchable
              styles={customStyles}
              formatOptionLabel={(option) => option.label}
              getOptionLabel={(option) => `+${getCountryCallingCode(option.value)}`} 
          />
            <div style={{ width: "1px", height: "60%", backgroundColor: "#D0D5DD" }} />
            <input
              type="text"
              placeholder="Enter pilot's mobile number"
              value={pilotDetails.phone}
              onChange={handlePhoneChange}
              style={{ flex: 1, border: "none", outline: "none", padding: "0 12px", height: "100%", fontSize: "14px" }}
            />
          </div>
          {errors.phone && <span style={{ color: "#D92D20", fontSize: "12px" }}>{errors.phone}</span>}
        </div>

        {/* Email */}

        <div className="flex flex-col gap-[0.2rem]">
          <label htmlFor="email" className="input-label">What is the pilot email address?</label>
          <input
            type="email"
            id="email"
            placeholder="Enter pilot's email address"
            value={pilotDetails.email}
            onChange={(e) => handleChange("email", e.target.value)}
            style={{
              width: "50%", height: "40px", padding: "8px 12px", borderRadius: "4px",
              border: errors.email ? "1px solid #D92D20" : "1px solid #D0D5DD",
              fontSize: "14px"
            }}
          />
          {errors.email && (
            <span style={{ color: "#D92D20", fontSize: "12px" }}>
              {errors.email}
            </span>
          )}
        </div>



        {/* licence_id */}
        <div className="flex flex-col gap-[0.2rem]">
          <label htmlFor="licence_id" className="input-label">What is pilot licence number?</label>
          <input
            type="text"
            id="licence_id"
            placeholder='Enter licence number'
            value={pilotDetails.licence_id}
            onChange={(e) => handleChange("licence_id", e.target.value)}
            style={{
              width: "50%", height: "40px", padding: "8px 12px", borderRadius: "4px",
              border: errors.licence_id ? "1px solid #D92D20" : "1px solid #D0D5DD",
              fontSize: "14px"
            }}
          />
          {errors.licence_id && <span style={{ color: "#D92D20", fontSize: "12px" }}>{errors.licence_id}</span>}
        </div>
      </div>
   )}
    </div>
  );
});

export default AddDronePilotForm;
